export const groupChatThreadTopic = "Gruppenchat";
